import axios from 'axios';
import { situatie_api } from './routes';
import { ISituatie } from '../utils/interfaces/interfaces';

const defaultEmpty = (value: string) => (value === '-' ? '#' : value + '#');

const updateTable = async (payload: ISituatie, year: string) => {
  /* remove suplimentary fields */

  const entries = payload.entries.map(entry => {
    const {
      dataAngajamentBugetar,
      dataAngajamentLegal,
      facturaData,
      facturaNr,
      ordonantarePlataData,
      ordonantarePlataNr,
      dataDataNotaIntrareReceptie,
      nrDataNotaIntrareReceptie,
      ...data
    } = entry;

    return {
      ...data,
      angajamentBugetar:
        defaultEmpty(data.angajamentBugetar) + dataAngajamentBugetar,
      angajamentLegal: defaultEmpty(data.angajamentLegal) + dataAngajamentLegal,
      facturaNrData: defaultEmpty(facturaNr) + facturaData,
      ordonantarePlata: defaultEmpty(ordonantarePlataNr) + ordonantarePlataData,
      nrDataNotaIntrareReceptie:
        defaultEmpty(nrDataNotaIntrareReceptie) + dataDataNotaIntrareReceptie
    };
  });
  return await axios.put(situatie_api.UPDATE, { year, entries });
};

const getTable = async (year: string) =>
  await axios.get(situatie_api.GET_ONE(year));

const getTables = async () => await axios.get(situatie_api.GET_ALL);

const deleteRow = async (year: string, id: string) =>
  await axios.delete(situatie_api.DELETE_ROW(year, id));

export { updateTable, getTable, getTables, deleteRow };
